import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { roleActions } from '@app/store/role/actions/role.actions';
import { rolesActions } from '../actions/roles.actions';
import { selectQuery } from '../selectors/roles.selector';

/** Deletes go through the `role` store; the list replays its last request once one succeeds. */
@Injectable()
export class RolesRoleBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    reloadAfterDelete$ = createEffect(() => {
        return this.actions.pipe(
            ofType(roleActions.deleteRoleSuccess),
            concatLatestFrom(() => this.store.select(selectQuery)),
            map(([, query]) => rolesActions.getRoles({ value: query })),
        );
    });
}
